import { Link, useLocation } from "@remix-run/react";
import { useEffect, useState } from "react";
import { useMarketCartState, useModalStore } from "~/utils";

import { Search } from "lucide-react";
import WordExpander from "./AnimatedTextLogo";

const Header = ({ locale }: { locale?: string }) => {
  const useCartState = useMarketCartState(locale);
  const totalItems = useCartState((state) => state.totalItems);
  const [hidden, setHidden] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const openModal = useModalStore((s) => s.openModal);
  const closeModal = useModalStore((s) => s.closeModal);
  const location = useLocation();

  // Handle the scroll direction and trigger hiding the header
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 58) {
        setHidden(true); // Hide navbar when scrolling down
        openModal("topNav");
      } else {
        setHidden(false); // Show navbar when scrolling up
        closeModal("topNav");
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Reset navbar when navigating back
  useEffect(() => {
    setHidden(false);
  }, [location.pathname]);

  useEffect(() => {
    setLoaded(true);
  }, [totalItems]);

  return (
    <header
      className={`flex justify-between px-4 md:px-6 bg-white h-14 py-4 sticky top-0 border-b-[0.5px] border-black z-20 transition-transform duration-300 ease-out ${
        hidden ? "transform -translate-y-full" : "transform translate-y-0"
      }`}
    >
      <Link
        to={`/${locale}`}
        className="font-masonExtendedExtraBold flex col-span-1 text-center font-light justify-center"
      >
        <WordExpander />
      </Link>

      <div className="flex justify-self-end justify-end gap-3 text-xl">
        <button
          type="button"
          aria-label="open search modal"
          onClick={() => openModal("search")}
        >
          <Search className="h-5 w-5 text-current" />
        </button>
        <button
          type="button"
          aria-label="open shopping bag"
          onClick={() => openModal("cart")}
        >
          <div className="relative">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.53699 18.5L3.46551 5.5H16.5344L17.463 18.5H2.53699Z"
                stroke="currentColor"
              ></path>
              <path
                d="M13 7.5C13 3.13636 12 1.5 10 1.5C8 1.5 7 3.13636 7 7.5"
                stroke="currentColor"
              ></path>
            </svg>
            {loaded && totalItems > 0 && (
              <span className=" absolute text-xs bg-black text-white rounded-full text-center left-3 bottom-1 cursor-pointer  h-5 w-5 leading-5">
                {totalItems}
              </span>
            )}{" "}
          </div>
        </button>
      </div>
    </header>
  );
};

export default Header;
